/* import __COLOCATED_TEMPLATE__ from './invite-form.hbs'; */
var _class;
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
import Component from '@glimmer/component';
import assert, { assertInstanceOf } from '@banking/ui/utils/assert';
import { action } from '@ember/object';
export let FieldIdentifier = /*#__PURE__*/function (FieldIdentifier) {
  FieldIdentifier["FIRST_NAME"] = "FIRST_NAME";
  FieldIdentifier["LAST_NAME"] = "LAST_NAME";
  FieldIdentifier["EMAIL_ADDRESS"] = "EMAIL_ADDRESS";
  return FieldIdentifier;
}({});
const NAME_FIELD_MAX_CHARACTER_LENGTH = 30;
let BankingCheckingOnboardingInviteForm = (_class = class BankingCheckingOnboardingInviteForm extends Component {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "FieldIdentifier", FieldIdentifier);
    _defineProperty(this, "NAME_FIELD_MAX_CHARACTER_LENGTH", NAME_FIELD_MAX_CHARACTER_LENGTH);
  }
  onInputChange(fieldCandidate, event) {
    assert(fieldCandidate != null && typeof fieldCandidate === 'string' && fieldCandidate in FieldIdentifier);
    // FIXME(steckel): Find a way to type-narrow over type-casting
    const fieldIdentifier = fieldCandidate;
    const val = assertInstanceOf(event, CustomEvent).detail.value;
    this.args.onValueChange(fieldIdentifier, val);
  }
  onFormSubmit(event) {
    // We wrap the input fields in a form to provide better accessibility.
    // Since we make the primaryCta type="submit" we want to make sure the
    // default form behavior isn't being invoked.
    event.preventDefault();
    this.args.onNextButtonClick?.();
  }
}, _applyDecoratedDescriptor(_class.prototype, "onInputChange", [action], Object.getOwnPropertyDescriptor(_class.prototype, "onInputChange"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "onFormSubmit", [action], Object.getOwnPropertyDescriptor(_class.prototype, "onFormSubmit"), _class.prototype), _class);
export { BankingCheckingOnboardingInviteForm as default };